<template>
    <div>
        <div
            v-if="!floating"
            :style="
                'position: fixed; z-index: 1000000;' +
                left +
                right +
                top +
                bottom
            " @click.prevent="floating = true"
        >
            <div
                style="
                    width: 10px;
                    height: 10px;
                    background-color: rgb(255, 0, 0);
                    position: absolute;
                    z-index: 1;
                    border-radius: 50%;
                    right: 20px;
                    top: 10px;
                    display: block !important;
                "
            ></div>
            <div
                style="
                    height: 64px;
                    box-shadow: rgb(0 0 0 / 15%) 0px 3px 12px;
                    border-radius: 50%;
                    display: flex;
                    -webkit-box-pack: center;
                    justify-content: center;
                    -webkit-box-align: center;
                    align-items: center;
                    cursor: pointer;
                    user-select: none;
                    position: relative;
                    outline: transparent;
                    background-color: rgb(14, 193, 47);
                    margin-bottom: 20px;
                    margin-right: 20px;
                    margin-left: 20px;
                    width: 64px;
                "
            >
                <a
                    aria-label="whatsapp"
                    href="#"
                    target="_blank"
                >
                    <i
                        class="fab fa-whatsapp"
                        style="font-size: 40px; color: #fff"
                    ></i>
                </a>
            </div>
        </div>
        <div
            v-else
            type="floating"
            class="Window__WindowComponent-sc-1wwhwms-1 llyszt"
            style="width: 360px;z-index: 1000;"
        >
            <div
                @click.prevent="floating = false"
                color="rgb(255, 255, 255)"
                role="button"
                tabindex="0"
                class="Close__Component-sc-9nuxpx-0 jquJIT"
            ></div>
            <div class="Header__Component-sc-5nh99s-0 iVAnmu">
                <div size="52" class="UserImage__Component-sc-1qu4hk4-0 dzEGMJ">
                    <div class="UserImage__ImageContainer-sc-1qu4hk4-1 jSnLdm">
                        <div class="UserImage__Image-sc-1qu4hk4-2 irpeNi"></div>
                    </div>
                </div>
                <div class="Header__Info-sc-5nh99s-1 cDWrEO">
                    <div class="Header__Name-sc-5nh99s-2 cbZbti">
                        Asesor comercial
                    </div>
                    <div class="Header__AnswerTime-sc-5nh99s-3 gHvZA-d">
                        <div>Solo piensalo, nosotros lo creamos</div>
                    </div>
                </div>
            </div>
            <div class="WhatsappChat__Component-sc-1nhdht4-0 eqIYb">
                <div class="WhatsappChat__MessageContainer-sc-1nhdht4-1 emLEvA">
                    <div
                        class="WhatsappDots__Component-sc-inte9t-0 eIODLm"
                        style="opacity: 0"
                    >
                        <div
                            class="WhatsappDots__ComponentInner-sc-inte9t-1 kcAHIS"
                        >
                            <div
                                class="WhatsappDots__Dot-sc-inte9t-2 WhatsappDots__DotOne-sc-inte9t-3 gFktBT devGdz"
                            ></div>
                            <div
                                class="WhatsappDots__Dot-sc-inte9t-2 WhatsappDots__DotTwo-sc-inte9t-4 gFktBT iweHrw"
                            ></div>
                            <div
                                class="WhatsappDots__Dot-sc-inte9t-2 WhatsappDots__DotThree-sc-inte9t-5 gFktBT ifXxgw"
                            ></div>
                        </div>
                    </div>
                    <div
                        class="WhatsappChat__Message-sc-1nhdht4-4 dBELLQ"
                        style="opacity: 1"
                    >
                        <div class="WhatsappChat__Author-sc-1nhdht4-3 fbPzzf">
                            Asesor
                        </div>
                        <div class="WhatsappChat__Text-sc-1nhdht4-2 kZdIfu">
                            <div>Hola 👋</div>
                            <div>Como podemos ayudarte?</div>
                        </div>
                        <div class="WhatsappChat__Time-sc-1nhdht4-5 isCfED">
                            {{ hours.toLocaleTimeString() }}
                        </div>
                    </div>
                </div>
            </div>
            <a
                role="button"
                target="_blank"
                :href="link"
                aria-label="WhatsApp"
                title="WhatsApp"
                style="text-decoration: none"
                class="DefaultButton__DefaultButtonComponent-sc-1v663dx-0 QTZeg"
                ><svg
                    width="20"
                    height="20"
                    viewBox="0 0 90 90"
                    xmlns="http://www.w3.org/2000/svg"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    class="WhatsappButton__Icon-sc-7zv9k4-0 gaaZOM"
                >
                    <path
                        d="M90,43.841c0,24.213-19.779,43.841-44.182,43.841c-7.747,0-15.025-1.98-21.357-5.455L0,90l7.975-23.522   c-4.023-6.606-6.34-14.354-6.34-22.637C1.635,19.628,21.416,0,45.818,0C70.223,0,90,19.628,90,43.841z M45.818,6.982   c-20.484,0-37.146,16.535-37.146,36.859c0,8.065,2.629,15.534,7.076,21.61L11.107,79.14l14.275-4.537   c5.865,3.851,12.891,6.097,20.437,6.097c20.481,0,37.146-16.533,37.146-36.857S66.301,6.982,45.818,6.982z M68.129,53.938   c-0.273-0.447-0.994-0.717-2.076-1.254c-1.084-0.537-6.41-3.138-7.4-3.495c-0.993-0.358-1.717-0.538-2.438,0.537   c-0.721,1.076-2.797,3.495-3.43,4.212c-0.632,0.719-1.263,0.809-2.347,0.271c-1.082-0.537-4.571-1.673-8.708-5.333   c-3.219-2.848-5.393-6.364-6.025-7.441c-0.631-1.075-0.066-1.656,0.475-2.191c0.488-0.482,1.084-1.255,1.625-1.882   c0.543-0.628,0.723-1.075,1.082-1.793c0.363-0.717,0.182-1.344-0.09-1.883c-0.27-0.537-2.438-5.825-3.34-7.977   c-0.902-2.15-1.803-1.792-2.436-1.792c-0.631,0-1.354-0.09-2.076-0.09c-0.722,0-1.896,0.269-2.889,1.344   c-0.992,1.076-3.789,3.676-3.789,8.963c0,5.288,3.879,10.397,4.422,11.113c0.541,0.716,7.49,11.92,18.5,16.223   C58.2,65.771,58.2,64.336,60.186,64.156c1.984-0.179,6.406-2.599,7.312-5.107C68.398,56.537,68.398,54.386,68.129,53.938z"
                    ></path></svg
                ><span
                    class="DefaultButton__DefaultButtonText-sc-1v663dx-1 ecYRLg"
                    >Iniciar Chat</span
                ></a
            >
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    mounted() {
        setTimeout(() => {
            this.getPosition();
            this.getUrl();
        }, 1000);
    },
    data: function () {
        return {
            url: "https://api.whatsapp.com/send?",
            phone: "phone=",
            text: "text=",
            link: null,
            left: null,
            right: null,
            top: null,
            bottom: null,
            floating: false,
            hours: new Date(),
            position: [
                {
                    left: 50,
                    right: null,
                    top: 50,
                    bottom: null,
                },
                {
                    left: null,
                    right: 50,
                    top: 50,
                    bottom: null,
                },
                {
                    left: 50,
                    right: null,
                    top: null,
                    bottom: 50,
                },
                {
                    left: null,
                    right: 50,
                    top: null,
                    bottom: 50,
                },
            ],
        };
    },
    methods: {
        getPosition() {
            let position = {
                left: 50,
                right: null,
                top: 50,
                bottom: null,
            };
            if (this.whatsapp.valor) {
                if (this.whatsapp.valor.posicion) {
                    position = this.position[this.whatsapp.valor.posicion];
                }
                this.left = this.setStyle(
                    "left:" +
                        (position.left + this.whatsapp.valor.derecha) +
                        "px;"
                );
                this.right = this.setStyle(
                    "right:" +
                        (position.right + this.whatsapp.valor.izquierda) +
                        "px;"
                );
                this.top = this.setStyle(
                    "top:" + (position.top + this.whatsapp.valor.arriba) + "px;"
                );
                this.bottom = this.setStyle(
                    "bottom:" +
                        (position.bottom + this.whatsapp.valor.abajo) +
                        "px;"
                );
            }
        },
        setStyle(value) {
            let exception = [
                "left:0px;",
                "right:0px;",
                "top:0px;",
                "bottom:0px;",
            ];
            if (exception.indexOf(value) > -1) {
                return "";
            }
            return value;
        },
        getUrl() {
            let value = "";
            if (this.whatsapp.valor) {
                if (this.whatsapp.valor.numero) {
                    value =
                        this.phone +
                        "+" +
                        this.whatsapp.valor.indicativo +
                        this.whatsapp.valor.numero;
                }
                if (this.whatsapp.valor.mensaje) {
                    if (value != "") {
                        value = value + "&";
                    }
                    value = value + this.text + this.whatsapp.valor.mensaje;
                }
            }
            this.link = this.url + value;
        },
    },
    computed: {
        ...mapState("preferencias", ["whatsapp"]),
    },
};
</script>

<style>
.llyszt {
    box-shadow: rgb(0 0 0 / 10%) 0px 12px 24px 0px;
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
    transition: opacity 0.3s ease 0s, margin 0.3s ease 0s,
        visibility 0.3s ease 0s;
    background-color: rgb(255, 255, 255);
    transform: translate3d(0px, 0px, 0px);
    opacity: 1;
    pointer-events: all;
    visibility: visible;
    touch-action: auto;
    margin-bottom: 96px;
    position: fixed;
    bottom: 0px;
    right: 0px;
    left: auto;
    margin-right: 20px;
}

.jquJIT {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 20px;
    height: 20px;
    opacity: 0.4;
    cursor: pointer;
    transition: all 0.3s ease 0s;
    outline: transparent;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    display: flex !important;
}

.iVAnmu {
    background: rgb(9, 94, 84);
    color: rgb(17, 17, 17);
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    padding: 24px 20px;
}

.eqIYb {
    padding: 20px 20px 20px 10px;
    background-color: rgb(230, 221, 212);
    position: relative;
    overflow: auto;
    max-height: 382px;
}

.eapp-whatsapp-chat-root-layout-component,
.eapp-whatsapp-chat-root-layout-component * {
    box-sizing: border-box !important;
    outline: none !important;
}

.eapp-whatsapp-chat-root-layout-component a {
    text-decoration: none;
}

.QTZeg {
    padding: 8px 12px;
    border-radius: 24px;
    border: none;
    background: rgb(14, 193, 47);
    color: rgb(255, 255, 255);
    font-size: 15px;
    font-weight: 700;
    line-height: 20px;
    cursor: pointer;
    position: relative;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    margin: 20px;
    overflow: hidden;
    appearance: none;
}

.eapp-whatsapp-chat-root-layout-component,
.eapp-whatsapp-chat-root-layout-component * {
    box-sizing: border-box !important;
    outline: none !important;
}

.fRqctP {
    height: 64px;
    box-shadow: rgb(0 0 0 / 15%) 0px 3px 12px;
    border-radius: 50%;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    cursor: pointer;
    user-select: none;
    position: relative;
    outline: transparent;
    background-color: rgb(14, 193, 47);
    margin-bottom: 20px;
    margin-right: 20px;
    margin-left: 20px;
    width: 64px;
}

.emLEvA {
    display: flex;
    z-index: 1;
}

.eqIYb::before {
    display: block;
    position: absolute;
    content: "";
    left: 0px;
    top: 0px;
    height: 100%;
    width: 100%;
    z-index: 0;
    opacity: 0.08;
    background-image: url(https://elfsight.com/assets/chats/patterns/whatsapp.png);
}

.kcAHIS {
    position: relative;
    display: flex;
}

.eIODLm {
    background-color: rgb(255, 255, 255);
    width: 52.5px;
    height: 32px;
    border-radius: 16px;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    margin-left: 10px;
    opacity: 0;
    transition: all 0.1s ease 0s;
    z-index: 1;
    box-shadow: rgb(0 0 0 / 13%) 0px 1px 0.5px;
}

.dzEGMJ::before {
    content: "";
    bottom: 0px;
    right: 0px;
    width: 12px;
    height: 12px;
    box-sizing: border-box;
    background-color: rgb(74, 213, 4);
    display: block;
    position: absolute;
    z-index: 1;
    border-radius: 50%;
    border: 2px solid rgb(9, 94, 84);
}

.fbPzzf {
    font-size: 13px;
    font-weight: 700;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.4);
}

.jSnLdm::after {
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.1);
    inset: 0px;
    position: absolute;
    content: "";
    overflow: hidden;
}

.isCfED {
    text-align: right;
    margin-top: 4px;
    font-size: 12px;
    line-height: 16px;
    color: rgba(17, 17, 17, 0.5);
    margin-right: -8px;
    margin-bottom: -4px;
}

.gHvZA-d {
    font-size: 13px;
    line-height: 18px;
    margin-top: 4px;
    color: rgb(255, 255, 255);
}

.cbZbti {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    color: rgb(255, 255, 255);
}

.dBELLQ {
    padding: 7px 14px 6px;
    background-color: rgb(255, 255, 255);
    border-radius: 0px 8px 8px;
    position: relative;
    transition: all 0.3s ease 0s;
    opacity: 0;
    transform-origin: center top;
    z-index: 2;
    box-shadow: rgb(0 0 0 / 13%) 0px 1px 0.5px;
    margin-top: 4px;
    margin-left: -54px;
    max-width: calc(100% - 66px);
}

.jquJIT::after {
    transform: rotate(-45deg);
}

.jquJIT::before,
.jquJIT::after {
    content: "";
    position: absolute;
    width: 12px;
    height: 2px;
    background-color: rgb(255, 255, 255);
    display: block;
    border-radius: 2px;
}

.jquJIT::before {
    transform: rotate(45deg);
}

.jquJIT::before,
.jquJIT::after {
    content: "";
    position: absolute;
    width: 12px;
    height: 2px;
    background-color: rgb(255, 255, 255);
    display: block;
    border-radius: 2px;
}

.irpeNi {
    min-width: 100%;
    height: 100%;
    flex-shrink: 0;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    background-image: url(/theme/images/cerebro.png);
    display: block !important;
}

.jSnLdm {
    height: 100%;
    width: 100%;
    overflow: hidden;
    border-radius: 50%;
    position: relative;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
}

.devGdz {
    background-color: rgb(158, 157, 162);
    animation-name: dJHihm;
}

.dzEGMJ {
    width: 52px;
    height: 52px;
    display: block;
    position: relative;
    flex-shrink: 0;
}

.cDWrEO {
    margin-left: 16px;
    margin-right: 16px;
}

.gFktBT {
    height: 5px;
    width: 5px;
    margin: 0px 2px;
    background-color: rgb(182, 181, 186);
    border-radius: 50%;
    position: relative;
    animation-duration: 1.2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    top: 0px;
    display: inline-block !important;
}

.carousel-inner,
.collapsing,
.dropdown-divider,
.embed-responsive,
.modal,
.modal-open,
.progress,
.sr-only,
svg:not(:root) {
    overflow: hidden;
}

.gaaZOM {
    width: 16px;
    height: 16px;
    flex: 0 0 16px;
    fill: rgb(255, 255, 255);
    z-index: 1;
}

.ecYRLg {
    margin-left: 8px;
    margin-right: 8px;
    z-index: 1;
    color: rgb(255, 255, 255);
}

.kZdIfu {
    font-size: 14px;
    line-height: 19px;
    margin-top: 4px;
    color: rgb(17, 17, 17);
}

.QTZeg:hover,
.QTZeg:focus {
    text-decoration: none !important;
}

.eapp-whatsapp-chat-root-layout-component a {
    text-decoration: none;
}
</style>
